import React, { useEffect, useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { useSelector, useDispatch } from 'react-redux'
import EstiagroLogo from '../../images/estiagro-logo.png'
import EsticampoLogo from '../../images/esticampo-logo.png'
import EstimotoLogo from '../../images/estimoto-logo.png'
import RadioInput from '../Fields/RadioInput/RadioInput'
import { vehicleTypes } from '../../consts/vehicleTypes'
import { FETCH_NEW_OFFERS_COUNT, SET_VEHICLE_TYPE } from '../../redux/VehicleTypeReducer'
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations'

const LogoMenu = ({ setLogoMenuOpen, avatarThumb, t, }) => {
  const ref = useRef();
  const dispatch = useDispatch();
  const { email, nickname, } = useSelector((state) => state.userData)
  const { vehicleType, new_motorbikes, new_campers, new_agricultural_machines, } = useSelector((state) => state.vehicleType)

  const classes = useStyles();
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setLogoMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    dispatch(FETCH_NEW_OFFERS_COUNT())
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const EstiagroLogoElement = useMemo(() => {
    return (
      <div className={classes.logo} dataTestId="Estiagro">
        <img src={EstiagroLogo} alt="Estiagro logo" />
        {new_agricultural_machines > 0 &&
          <div className={classes.badge}>
            {new_agricultural_machines} {t('new_offers')}
          </div>
        }
      </div>
    )
  }, [new_agricultural_machines])

  const EsticampoLogoElement = useMemo(() => {
    return (
      <div className={classes.logo}>
        <img src={EsticampoLogo} alt="Esticampo logo" />
        {new_campers > 0 &&
          <div className={classes.badge}>
            {new_campers} {t('new_offers')}
          </div>
        }
      </div>
    )
  }, [new_campers])

  const EstimotoLogoElement = useMemo(() => {
    return (
      <>
        <div className={classes.logo}>
          <img src={EstimotoLogo} alt="Estimoto logo" />
          {new_motorbikes > 0 &&
            <div className={classes.badge}>
              {new_motorbikes} {t('new_offers')}
            </div>
          }
        </div>
      </>
    )
  }, [new_motorbikes])

  return (
    <div ref={ref} className={`${classes.logoMenu} slide-in`}>
      <img src={avatarThumb} alt="User name" className={classes.avatarImg} />
      <br />
      <strong>{nickname}</strong>
      {email}
      <hr></hr>
      <div>
        <RadioInput
          input={{ value: vehicleType, onChange: (value) => dispatch(SET_VEHICLE_TYPE(value)), }} meta={{}}
          options={[
            { label: EstiagroLogoElement, value: vehicleTypes.AgriculturalMachine, },
            { label: EsticampoLogoElement, value: vehicleTypes.Camper, },
            { label: EstimotoLogoElement, value: vehicleTypes.Motorbike, }
          ]}
        />
      </div>
    </div>
  )
}

LogoMenu.propTypes = {
  setLogoMenuOpen: PropTypes.func.isRequired,
  avatarThumb: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}


const useStyles = createUseStyles({
  logoMenu: {
    top: '50px',
    right: '50px',
    position: 'absolute',
    zIndex: '1',
    background: 'white',
    padding: '20px',
    boxShadow: '-3px 10px 31px -1px rgba(0, 0, 0, 0.5)',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '300px',
    '& hr': {
      width: 'calc(100% + 40px)',
      marginLeft: '-20px',
      borderWidth: '2px',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& img': {
      width: '150px',
      marginTop: '5px',
      marginLeft: 'px',
    },
  },
  avatarImg: {
    width: '50px',
    height: '50px',
    margin: '0 12px',
    borderRadius: '50px',
    border: '1px solid #e5e3e8',
  },

  badge: {
    display: 'inline-block',
    padding: '1px 7px',
    border: '1px solid #faaf3a',
    borderRadius: '5px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#faaf3a',
    background: '#feefd8',
    marginLeft: '10px',
  },
  '@media (max-width: 900px)': {
    logoMenu: {
      padding: '10px',
      width: '94%',
      minWidth: 'fit-content',
      right: '3%',
      '& hr': {
        width: 'calc(100% + 20px)',
        marginLeft: '-10px',
      },
    },
  },
})

export default withScopedTranslations('breadcrumbs.browse')(LogoMenu)
